import { compose, hoistStatics, lifecycle, withHandlers, withProps, withState, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import _ from 'lodash';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as R from 'ramda';

import Chat from './Chat';
import fh from '../../../../helpers/form.helper';
import ChannelsService from '../../../../services/channels.service';
import { messageActions } from '../../../../reducers/messages';
import { wsOperations } from '../../../../reducers/websockets';
import { uploadActions } from '../../../../reducers/upload';
// import fs from '../../../../services/file.service';
// TODO: В КОМПОНЕНТІ MANAGE ТЕЖ
const moveChatToEnd = () => {
  const chat = document.getElementById('messages-list'); // move scroll to the last message
  setTimeout(() => {
    if (chat) chat.scrollTo(0, chat.scrollHeight);
  }, 500);
};

const moveChatInToView = (id) => {
  const msg = document.getElementById(id);
  if (msg) msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

const readMessage = ({ changeChatAttr, clearNewMessage }) => async (unread_count, chatId) => {
  const response = await ChannelsService.readMessage({ id: chatId, count: unread_count });

  if (response) {
    const { unread_count: unreadCount } = response;
    if (typeof unreadCount === 'number') {
      const attributes = { unread_count: unreadCount };
      clearNewMessage();
      changeChatAttr({ attributes, channel_id: chatId });
    }
  }
};

const addNewMessage = props => async (e, data) => {
  const {
    user,
    chatId,
    messenger,
    addMessage,
    upload_name,
    mulTempFiles,
    unread_count,
    removeMulTempFiles,
  } = props;
  const files = mulTempFiles[upload_name] || [];
  const filesIds = files.map(file => (file.id));
  const resp = await ChannelsService.updateMessage({
    id: chatId,
    props: { content: data.message, files: filesIds },
  });
  if (resp.message) {
    addMessage({ channel: messenger[chatId], message: resp.message, user });
  }
  removeMulTempFiles(upload_name);
  moveChatToEnd();
  readMessage(props)(unread_count, chatId);
  return resp;
};

const editMessageSubmit = props => async (e, data) => {
  e.preventDefault();
  const {
    chatId,
    editMessage,
    upload_name,
    mulTempFiles,
    messageToEdit,
    setMessageToEdit,
    removeMulTempFiles,
  } = props;
  const files = mulTempFiles[upload_name] || [];
  const filesIds = files.map(file => (file.id));
  const prevFiles = messageToEdit.files.map(file => file.id)
    .filter(fileId => !filesIds.includes(fileId));
  if (prevFiles) {
    for (let i = 0; i < prevFiles.length; i += 1) {
      // await fs.destroyExisting(prevFiles[i]);
    }
  }
  const resp = await ChannelsService.updateMessage({
    id: chatId,
    props: { content: data.message, id: messageToEdit.id, files: filesIds },
  });
  setMessageToEdit(null);
  if (!resp.errors) {
    editMessage({ id: messageToEdit.id,
      channel_id: chatId,
      content: resp.message.content,
      files: resp.message.files,
    });
  }
  removeMulTempFiles(upload_name);
  return resp;
};

const onRemoveCallback = props => async () => {
  const { messageToDel, setShowConfirm, chatId, t } = props;
  await ChannelsService.removeMessage({
    id: chatId,
    messageId: messageToDel.id,
  });
  setShowConfirm(false);
  toast.success(t('Message removed'));
};

const hideConfirm = ({ setShowConfirm }) => () => { setShowConfirm(false); };

const setRemoveMessage = props => (e, message) => {
  e.preventDefault();
  const { setShowConfirm, setMessageToDel } = props;
  setShowConfirm(true);
  setMessageToDel(message);
};

const loadMoreStartId = props => async (chatId) => {
  const { messageCriteria, history, addChat, setSearchMessage, changeChatAttr } = props;
  const { channel } = await ChannelsService.get(chatId);

  if (channel) {
    changeChatAttr({ attributes: channel, channel_id: chatId });
    if (channel.unread_count) readMessage(props)(channel.unread_count, chatId);
  }

  const data = await ChannelsService.getMessages({ id: chatId, props: messageCriteria });
  const dataAll = await ChannelsService.getMessages({ id: chatId, props: { limit: 1 } });

  if (data) {
    const { message, hasMore, count } = data;

    if (message) {
      history.push('/messages');
    } else {
      const downMsgCount = (count + 1) - messageCriteria.limit;
      addChat({
        ...data,
        id: parseInt(chatId, 10),
        hasMoreDown: hasMore,
        hasMoreAbove: dataAll.count > count,
        downMsgCount,
        leftToLoadDown: downMsgCount,
        searchLoad: true,
        loadedMsgCount: count,
      });
    }
  }

  moveChatInToView(`msg-${messageCriteria.startId}`);
  setSearchMessage(null);
};

const loadMoreInitial = props => async (chatId) => {
  const { messageCriteria, addChat, changeChatAttr, history } = props;
  const { channel } = await ChannelsService.get(chatId);

  const newProps = messageCriteria.startId !== undefined
    ? messageCriteria
    : { ...messageCriteria, offset: 0 };

  if (channel.unread_count) readMessage(props)(channel.unread_count, chatId);
  const data = await ChannelsService.getMessages({ id: chatId, props: newProps });
  changeChatAttr({ attributes: channel, channel_id: chatId });

  if (data.message) {
    history.push('/messages');
  } else {
    addChat({
      ...data,
      id: parseInt(chatId, 10),
      page: 0,
      searchLoad: false,
      hasMoreAbove: data.hasMore,
    });
  }
};

const loadNextPageSearch = props => async (nextPage, chatId) => {
  const { messenger, messageCriteria, addMessages } = props;
  const msgInfo = messenger[chatId].messages;
  if (nextPage === -1) {
    if (msgInfo.leftToLoadDown < messageCriteria.limit) {
      const newProps = { ...messageCriteria, offset: 0, limit: msgInfo.leftToLoadDown };
      const data = await ChannelsService.getMessages({ id: chatId, props: newProps });

      addMessages({
        ...data,
        ...msgInfo,
        id: chatId,
        page: nextPage,
        direction: -1,
        searchLoad: true,
        hasMoreDown: false,
        leftToLoadDown: 0,
      });
    } else {
      const newProps = { ...messageCriteria, offset: msgInfo.leftToLoadDown - messageCriteria.limit };
      const data = await ChannelsService.getMessages({ id: chatId, props: newProps });

      addMessages({
        ...data,
        ...msgInfo,
        id: chatId,
        page: nextPage,
        direction: -1,
        searchLoad: true,
        hasMoreDown: true,
        leftToLoadDown: msgInfo.leftToLoadDown - messageCriteria.limit,
      });
    }
  } else if (msgInfo.hasMoreAbove) {
    const newProps = { ...messageCriteria, offset: msgInfo.loadedMsgCount };
    const data = await ChannelsService.getMessages({ id: chatId, props: newProps });
    const loadedMsgCount = msgInfo.loadedMsgCount + data.data.length;

    addMessages({
      ...data,
      ...msgInfo,
      id: chatId,
      direction: 0,
      loadedMsgCount,
      hasMoreAbove: data.hasMore,
    });
  }
};

const loadNextPageSimple = props => async (nextPage, chatId) => {
  const { messageCriteria, history, addMessages } = props;
  const newProps = messageCriteria.startId !== undefined
    ? messageCriteria
    : { ...messageCriteria, offset: nextPage * messageCriteria.limit };

  const data = await ChannelsService.getMessages({ id: chatId, props: newProps });

  if (data.errors) {
    history.push('/messages');
  } else {
    addMessages({
      ...data,
      id: chatId,
      page: nextPage,
      direction: 0,
      searchLoad: false,
      hasMoreAbove: data.hasMore,
      hasMoreDown: false,
    });
  }
};

const loadMore = props => _.debounce(async (nextPage) => {
  const { messageCriteria, messenger, setIsLoadingData, match: { params: { id: chatId } } } = props;
  setIsLoadingData(true);
  if (messageCriteria.startId !== undefined) {
    await loadMoreStartId(props)(chatId);
  } else if (!(messenger[chatId] && messenger[chatId].messages)) {
    await loadMoreInitial(props)(chatId);
  } else {
    const { loadedPages } = messenger[chatId].messages;
    if (!nextPage) {
      if (messenger[chatId].searchLoad) {
        await loadMoreInitial(props)(chatId);
      }
    } else if (messenger[chatId].messages.searchLoad) {
      await loadNextPageSearch(props)(nextPage, chatId);
    } else if (!loadedPages.includes(nextPage)) {
      await loadNextPageSimple(props)(nextPage, chatId);
    }
  }

  setIsLoadingData(false);
}, 750, { leading: true });

const onScrollChat = props => async (e) => {
  const hasScroll = e.target && e.target.scrollHeight;
  const { messenger, isLoadingData } = props;
  const chatId = props.match.params.id;
  if (hasScroll) {
    const scrollToBottom = e.target.scrollHeight - e.target.scrollTop - e.target.offsetHeight;
    if (scrollToBottom < 400
      && messenger[chatId]
      && messenger[chatId].messages
      && messenger[chatId].messages.hasMoreDown
      && !isLoadingData) {
      await loadMore(props)(-1);
    }
  }
};

const loadWithStartMessage = props => async ({ message_id }) => {
  await loadMore({
    ...props,
    messageCriteria: {
      ...props.messageCriteria,
      startId: message_id,
    },
  })(0);
};

const mapStateToProps = state => ({
  defaultLang: state.settings.defaultLanguage,
  mulTempFiles: state.upload.mulTempFiles,
  messenger: state.messenger,
  user: state.user.user,
});

const mapDispatchToProps = {
  addChat: messageActions.addChat,
  addMessage: messageActions.addMessage,
  addMessages: messageActions.addMessages,
  editMessage: messageActions.editMessage,
  changeChatAttr: messageActions.changeChatAttr,
  clearNewMessage: messageActions.clearNewMessage,
  changeActiveChat: messageActions.changeActiveChat,
  subscribeToChannel: wsOperations.subscribeToChannel,
  removeMulTempFiles: uploadActions.removeMulTempFiles,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  ...fh.defaultRecompose({ }),
  translate('portal'),
  withState('showConfirm', 'setShowConfirm', false),
  withState('messageToDel', 'setMessageToDel', -1),
  withState('messageToEdit', 'setMessageToEdit', null),
  withState('chatHasLoaded', 'setChatHasLoaded', false),
  withState('isLoadingData', 'setIsLoadingData', false),
  withProps((props) => {
    const { messenger, match } = props;
    const chatId = match && match.params && match.params.id
      ? match.params.id
      : -1;

    const areMessages = messenger[chatId]
      && messenger[chatId].messages
      && messenger[chatId].messages.entities;

    const messages = areMessages
      ? messenger[chatId].messages.entities
      : null;

    const unread_count = messenger[chatId] && messenger[chatId].unread_count
      ? messenger[chatId].unread_count
      : 0;

    return {
      ...props,
      messages,
      chatId,
      unread_count,
      hasMore: areMessages ? messenger[chatId].messages.hasMoreAbove : false,
    };
  }),
  lifecycle({
    async componentDidMount() {
      const { subscribeToChannel, setChatHasLoaded, changeActiveChat, searchMessage, match: { params: { id: chatId } } } = this.props;

      setChatHasLoaded(false);
      changeActiveChat({ id: chatId });

      if (searchMessage) await loadWithStartMessage(this.props)(searchMessage);
      else await loadMore(this.props)(0);
      subscribeToChannel(`channel:${chatId}`);
      moveChatToEnd();

      setChatHasLoaded(true);
    },
    async componentDidUpdate(prevProps) {
      if (!R.equals(this.props.searchMessage, prevProps.searchMessage)) {
        if (this.props.searchMessage) {
          await loadWithStartMessage(this.props)(this.props.searchMessage);
        }
      } else if (this.props.match.params.id !== prevProps.match.params.id) {
        const { setChatHasLoaded, subscribeToChannel, changeActiveChat, match } = this.props;
        const chatId = match.params.id;
        changeActiveChat({ id: chatId });
        setChatHasLoaded(false);
        await loadMore(this.props)(0);
        moveChatToEnd();
        subscribeToChannel(`channel:${chatId}`);
        setChatHasLoaded(true);
      }
    },
  }),
  defaultProps({
    upload_name: 'message-new',
  }),
  withHandlers({
    addNewMessage,
    editMessageSubmit,
    onSubmit: editMessageSubmit,
    enterMessage: fh.onChangeFormDataElement,
    setRemoveMessage,
    hideConfirm,
    loadMore,
    readMessage,
    onRemoveCallback,
    onScrollChat,
  }),
);

export default hoistStatics(enhance)(Chat);



// WEBPACK FOOTER //
// ./src/views/modules/messages/chat/index.js